<template>
  <form class="export-button-form" :action="url" target="_blank" method="post">
    <input type="hidden" name="auth_token" :value="jwt" />
    <input type="hidden" v-for="(value, key) in params" :key="key" :name="key" :value="value" />
    <button type="submit" :class="buttonClass" :style="buttonStyle">
      <slot />
    </button>
  </form>
</template>

<script>
export default {
  inheritAttrs: false,
  data: function() {
    return {
      jwt: localStorage.jwt
    }
  },
  props: ['url', 'buttonClass', 'buttonStyle'],
  computed: {
    params() {
      return this.$attrs
    }
  }
}
</script>

<style scoped lang="scss">
.export-button-form {
  display: inline-block;
}
</style>